import { render, staticRenderFns } from "./modalSpekKhusus.vue?vue&type=template&id=0af95ea4&"
import script from "./modalSpekKhusus.vue?vue&type=script&lang=js&"
export * from "./modalSpekKhusus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports